let dummyImg =  {
	h_pc: [0, 1, 2, 3, 4, 5],
	v_pc: [0, 1, 2, 3],
	h_sp: [0, 1, 2, 3],
	h_pc_count: 0,
	v_pc_count: 0,
	sp_count: 0
}
export let indexGrid = {
	data: [],
	target: null,
	patternNum: [
		[ 1, 3, 1, 4, 4],
		[ 1, 3, 4, 0, 1],
		[ 3, 1, 3,
			1, 0, 3, 4, 4, 4]
	],
	repeatNum: 0,
	resetNum: 0,
	_shuffle(arr){
		const a = [...arr];
		for(let i=a.length-1;i>0;i--){
			const j = Math.floor(Math.random()*(i+1));
			[a[i],a[j]] = [a[j],a[i]];
		}
		return a;
	},
	_prepare(items){
		// priorityがnull/undefinedを弾く → 全体シャッフル → priority昇順
		//const filtered = items.filter(it => it.priority != null);
		const filtered = items.filter(it => {
			const p = Number(it.priority);
			return Number.isFinite(p) && p >= 1 && p <= 4;
		});
		const shuffled = this._shuffle(filtered);
		return shuffled.sort((a,b)=> Number(a.priority)-Number(b.priority));
	},
	init: function( items ){
		const data = [...items];
		//for (let i = 0; i < 3; i++) data.push(...items); // 副作用なしで増量
		const prepared = this._prepare(data);
		this.data = prepared;
		//console.log("json:", this.data);
		this.target = document.querySelector('#top_content .c-list_items ul');
		//indexGrid.target.innerHTML = "";
		// 何スロット分の li を1周期で作るか（0 の数も正確に差し引き）
		this.repeatNum = this.patternNum.reduce((sum, arr)=>{
		  const zeros = arr.filter(n => n===0).length;
		  return sum + (arr.length - zeros);
		}, 0);
		
		//console.log(indexGrid.data);
		indexGrid.repeatNum = 0;
		indexGrid.patternNum.forEach( (n) => {
			indexGrid.repeatNum += n.length;
			indexGrid.resetNum += n.length;
			if( n.includes(0) ){
				indexGrid.repeatNum -= 1;
			}
		});
		
		//indexGrid.target.innerHTML = indexGrid.getKv();
		indexGrid.makeHTML();
	},
	getKv: function(){
		return  `<li class="i-kv">
			<div class="img_kv">
			  <figure>
				<picture>
				  <source media="(min-width: 960px)" srcset="/assets/images/top/img_kv_pc.webp" width="1515" height="1026" decoding="async"/><img src="/assets/images/top/img_kv_sp.webp" width="393" height="737" decoding="async" loading="lazy" alt=""/>
				</picture>
			  </figure>
			</div>
		  </li>`;
	},
	makeHTML: function(){
		let HTML = "";
		
		let len 			= indexGrid.data.length;
		let patternCount 	= Math.ceil( len / indexGrid.repeatNum );
		
		//console.log(len, indexGrid.repeatNum, patternCount)
		
		let patternCurrentCount = 0; //パターン内で何番目か
		let count 		= 0;
		let patternNum 	= 0;
		
		let addLastCount = 0;
		for( let i = 0; i < patternCount; i++){
			let patternCount 	= 0;
			let hasPriority4Dummy = false;
			let hasPriority4Dummy2 = false;//pattern=1用
			
			indexGrid.patternNum.forEach( (n) => {
				let patternType 	= patternNum % indexGrid.patternNum.length;
				patternCurrentCount　= 0;
				if( patternType === 0 || patternType === 1 ){
					hasPriority4Dummy = false;
				}
				//console.log("Pattern Number:", patternNum, "PatteryType:", patternType)
				let p4arry = [4, 6, 7, 8];
				let p2arry = [0, 2, 3, 5];
				let pattern1DummyNum4 = Math.floor( Math.random()*p4arry.length );//パターン1用のpriority=4用のダミー
				let pattern1DummyNum2 = Math.floor( Math.random()*p2arry.length );//パターン1用のpriority=4用のダミー
				
				let isPattern1Dummy4 = p4arry[pattern1DummyNum4];
				let isPattern1Dummy2 = p2arry[pattern1DummyNum2];
				//console.log(isPattern1Dummy2, isPattern1Dummy4);
				for( let j = 0; j < n.length; j++){
					let d = indexGrid.data[count];
					if( d ){
						//img = d.images[0];
						let dataPriority = n[j];
						if( patternType === 0 ){
							if( j === 4 ){
								let isDummy = Math.random()*1 > .5;
								if( isDummy ){
									hasPriority4Dummy = true;
									dataPriority = 0;
								}
							}else if( j === 5 ){
								if( hasPriority4Dummy ){
									dataPriority = n[j];
								}else{
									dataPriority = 0;
								}
							}
						}
						if( patternType === 1 ){
							if( j === 2 ){
								let isDummy = Math.random()*1 > .5;
								if( isDummy ){
									hasPriority4Dummy = true;
									dataPriority = 0;
								}
							}else if( j === 3 ){
								if( hasPriority4Dummy ){
									dataPriority = n[j-1];
								}else{
									dataPriority = 0;
								}
							}
						}
						if( patternType === 2 ){
							if( j === 4 || j === 6 || j === 7 || j === 8){
								if( j === isPattern1Dummy4 ){
									dataPriority = 0;
								}else{
									dataPriority = n[j-1];
								}
							}
							if( j === 0 || j === 2 || j === 3 || j === 5){
								if( j === isPattern1Dummy2 ){
									dataPriority = 0;
									//console.log(patternType, isPattern1Dummy2);
								}else{
									let p = n[j];
									if( p === 0 ){
										p = 2;
									}
									//console.log("pattern1:", j, p)
									dataPriority = p;
								}
							}
						}
						
						//console.log(patternType)
						HTML += `<li class="i${patternCount}" data-priority="${dataPriority}" data-pattern="${patternType}" data-base-pattern="${n[j]}"></li>`;
						patternCount++;
						if(n[j] != 0){
							count++;
						}
						patternCurrentCount++;
					}else{
						let dataPriority = indexGrid.patternNum[patternType][patternCurrentCount];
						HTML += `<li class="i${patternCount} filled" data-priority="0" data-pattern="${patternType}" data-base-pattern="${n[j]}"></li>`;
						//console.log(patternCurrentCount);
						patternCurrentCount++;
						patternCount++;
					}
					//console.log(d);
				}
				patternNum++;
			});
		}
		
		indexGrid.target.insertAdjacentHTML("beforeend", HTML);
		indexGrid.addContent();
	},
	addContent: function(){
		let thisData = indexGrid.data;
		let count 	= 0;
		let p1 = indexGrid.target.querySelectorAll(`li[data-priority="1"]:not(.filled)`);
		p1.forEach( (li, index) => {
			let d = thisData[count];
			if( d ){
				li.innerHTML = indexGrid.getContent(d);
				li.setAttribute("data-set-priority", d.priority);
			}else{
				
			}
			
			count++;
		});
		let p2 = indexGrid.target.querySelectorAll(`li[data-priority="2"]:not(.filled)`);
		p2.forEach( (li, index) => {
			let d = thisData[count];
			if( d ){
				li.innerHTML = indexGrid.getContent(d);
				li.setAttribute("data-set-priority", d.priority);
			}else{
				
			}
			
			count++;
		});
		let p3 = indexGrid.target.querySelectorAll(`li[data-priority="3"]:not(.filled)`);
		p3.forEach( (li, index) => {
			let d = thisData[count];
			if( d ){
				li.innerHTML = indexGrid.getContent(d);
				li.setAttribute("data-set-priority", d.priority);
			}else{
				
			}
			count++;
		});
		let p4 = indexGrid.target.querySelectorAll(`li[data-priority="4"]:not(.filled)`);
		p4.forEach( (li, index) => {
			let d = thisData[count];
			if( d ){
				li.innerHTML = indexGrid.getContent(d);
				li.setAttribute("data-set-priority", d.priority);
			}else{
				
			}
			count++;
		});
		
		let p0 = indexGrid.target.querySelectorAll(`li[data-priority="0"]`);
		//console.log(p0)
		p0.forEach( (li, index) => {
			li.innerHTML = indexGrid.getDmyContent(li);
			li.setAttribute("data-set-priority", "0");
			//count++;
		});
		//console.log(count, indexGrid.data);
		/*
		const img = item.images && item.images[0];
		li.innerHTML = `
		  
		`;
		*/
		indexGridSp.init();
	},
	getContent: function(item){
		let img = item.images[0];
		let ttl = item.title_en;
		let words = ttl.split(" ").map((word, i) => {
			if (i === 0) {
				// 最初の単語だけ特別処理
				let firstChar = word.charAt(0);            // "A"
				let rest = word.slice(1);                  // "bout"
				
				return `<span><span class="fl">${firstChar}</span>${rest}</span>`;
			}
			return `<span>${word}</span>`;
		});
		let ttl2 = words.join(" ");
		//console.log(item);
		let isBlack = "";
		let isGray 	= "";
		if( item.is_black ){
			isBlack = "black";
		}
		if( item.is_gray ){
			isGray = "gray";
		}
		let url = item.url;
		if( url ){
			url = url.replace(/^https?:\/\/[^/]+/, "")
		}
		let itemTitle = "";
		let h3 = "";
		if( url.includes("products/")){
			//console.log(item)
			itemTitle = ``;
			h3 = `<span>${item.title}</span>`
		}else{
			h3 = `<span>${ttl[0]}</span>`;
			itemTitle = `
				<p class="en">${ttl2}</p>
				<p class="ja"><span>${item.title_ja}</span></p>`;
		}
		//console.log(img.url)
		let HTML = `
					<a href="${url}" class="js-pjax ${isBlack} ${isGray}">
						<figure>
						${img ? `<img src="${img.url}" width="${img.width}" height="${img.height}" alt="${img.alt||''}" loading="lazy">` : ''}
						</figure>
						<div class="item_ttl">
							<div class="txt">
								${itemTitle}
							</div>
							<h3>${h3}</h3>
						</div>
					</a>
					`;
		return HTML
	},
	getDmyContent: function( dom ){
		let spImg = dummyImg.sp_count % dummyImg.h_sp.length;
		let n = new Date();
		let t = n.getTime();
		//PC
		let patternNum = dom.getAttribute("data-base-pattern");
		let pcImg = "";
		let pcW = 0;
		let pcH = 0;
		if( patternNum === "4" || patternNum === "0" ){
			pcImg = "d_h" + dummyImg.h_pc_count % dummyImg.h_pc.length;
			dummyImg.h_pc_count++;
			pcW = 540;
			pcH = 370;
		}else{
			pcImg = "d_v" + dummyImg.v_pc_count % dummyImg.v_pc.length;
			dummyImg.v_pc_count++;
			pcW = 540;
			pcH = 740;
		}
		//console.log(patternNum, "pcImg:", pcImg)
		let HTML = `	
						<figure class="dmy">
							<img src="/cdn/shop/t/3/assets/${pcImg}.webp?v=${t}" alt="REGAL Roots & Routes" width="${pcW}" height="${pcH}" loading="lazy">
						</figure>
					`;
					
		dummyImg.sp++;
		return HTML;
		/*
		<source media="(max-width: 959px)" srcset="/cdn/shop/t/3/assets/d_h${spImg}_sp.webp?v=${t}" width="540" height="960" decoding="async"/>
		<source media="(min-width: 960px)" srcset="/cdn/shop/t/3/assets/${pcImg}.webp?v=${t}" width="${pcW}" height="${pcH}" decoding="async"/>
		*/
	}
}

let indexGridSp = {
	isSP: false,
	target: null,
	init: function(){
		indexGridSp.isSP = window.matchMedia('all and (max-width : 960px)').matches
		const items = document.querySelectorAll('#top_content .c-list_items ul > li');
		//console.log("sp init")
		const observer = new IntersectionObserver((entries) => {
			entries.forEach(entry => {
				if (entry.isIntersecting) {
					// 一旦全部のactiveを外す
					items.forEach(el => el.classList.remove('active'));
					
					// 表示されている要素にactiveを追加
					entry.target.classList.add('active');
				}
			});
		}, {
			root: null,           // ビューポート基準
			threshold: .95        // 60%以上見えたら「表示中」と判定
		});
		items.forEach(el => observer.observe(el));
	},
	check: function(){
		
	}
}